import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-30 justify-content-center justify-content-sm-between"
};
const _hoisted_5 = {
  class: "col-ms-12 col-md-4 col-lg-8"
};
const _hoisted_6 = {
  class: "group-5 d-flex flex-wrap align-items-center justify-content-between"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 0,
  class: "col-4 col-md-8 col-lg-4 text-center text-md-left"
};
const _hoisted_9 = {
  class: "image-block"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 0,
  class: "list list-divided list-divided-sm"
};
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { lawyerInfo } from '@/api/team';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'team-member',
  setup(__props) {
    const route = useRoute();
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });
    const info = ref(null);
    const isMobile = computed(() => {
      return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
    });
    const getData = async () => {
      if (!route.query.id) {
        return ElMessage.error('参数错误');
      }
      const data = await lawyerInfo(route.query.id);
      if (data) {
        if (data?.avatar) data.avatar = path.value + data.avatar;
        if (data.description) {
          data.description = data.description.split('\n');
        }
        info.value = data;
      }
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        bg: isMobile.value ? info.value?.avatar : '/images/background/bg1.png'
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h2", null, _toDisplayString(info.value?.name), 1)]), _createElementVNode("p", {
        innerHTML: info.value?.content
      }, null, 8, _hoisted_7)]), !isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [info.value?.avatar ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: info.value?.avatar,
        alt: "",
        width: "300",
        height: "382"
      }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]), info.value?.description ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.description, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-item",
          key: index
        }, _toDisplayString(item), 1);
      }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};